import { IApplicantDocument } from "@/src/types/applicant";
import { IRowData } from "@/src/types/applicationOnline";

export type ApplicantDocumentsTab = "all" | "students" | "university";

export type ApplicantDocumentTypeFilter = "all" | "passport" | "certificate" | "education" | "another";

const isApplicantDocument = (item: unknown): item is IApplicantDocument =>
  typeof item === "object" &&
  item !== null &&
  "file_type" in item &&
  "document_type" in item &&
  "file_path" in item;

export const getApplicantDocumentsFromUserInfo = (userInfo: IRowData["userInfo"] | undefined): IApplicantDocument[] | null => {
  const raw = userInfo?.documents as unknown;
  if (!Array.isArray(raw)) return null;
  if (raw.length === 0) return [];
  return isApplicantDocument(raw[0]) ? (raw as IApplicantDocument[]) : null;
};

export const filterApplicantDocuments = (
  documents: IApplicantDocument[],
  tab: ApplicantDocumentsTab,
  typeFilter: ApplicantDocumentTypeFilter,
): IApplicantDocument[] => {
  let filtered = documents;

  if (tab === "students") {
    filtered = filtered.filter((doc) => doc.file_type === "applicant");
  } else if (tab === "university") {
    filtered = filtered.filter((doc) => doc.file_type === "university");
  }

  if (typeFilter !== "all") {
    filtered = filtered.filter((doc) => doc.document_type === typeFilter);
  }

  return filtered;
};

export const selectorLabelToDocumentType = (label: string): ApplicantDocumentTypeFilter => {
  switch (label) {
    case "Passort":
      return "passport";
    case "Certificate":
      return "certificate";
    case "Education":
      return "education";
    case "Another":
      return "another";
    default:
      return "all";
  }
};
